module.exports = __webpack_public_path__ + "static/media/Icon - solarpower sm.7b3e55c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/elements/Icon - solarpower sm.svg
// module id = 168
// module chunks = 0